module.exports = __webpack_public_path__ + "img/bd5f4b0.jpg";